import { 
	createSlice,
} from '@reduxjs/toolkit'


const eventViewerSlice = createSlice({
	name: 'progress',
	initialState:{
		show:false,
		event:null,
		type:null,
	},
	reducers: {
		openViewer:(state,action)=>{
			const {type,event} = action.payload
			state.show = true
			state.event = event
			state.type = type
		},
		closeViewer:(state)=>{
			state.show = false
			state.event = null
			state.type = null
		}
	}
})

export const {openViewer,closeViewer} = eventViewerSlice.actions



export default eventViewerSlice.reducer